module.exports = __webpack_public_path__ + "static/media/fruitbar-bucket.9f38dfb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/parallaxSplit/fruitbar-bucket.jpg
// module id = 101
// module chunks = 0